import { render, staticRenderFns } from "./chatGptModal.vue?vue&type=template&id=109ba778&scoped=true&"
import script from "./chatGptModal.vue?vue&type=script&lang=ts&"
export * from "./chatGptModal.vue?vue&type=script&lang=ts&"
import style0 from "./chatGptModal.vue?vue&type=style&index=0&id=109ba778&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109ba778",
  null
  
)

export default component.exports